import request from '../../untils/request';

export function selectList(data) {
  return request({
    url: '/payOrderWater/selectList',
    method: 'get',
    params: data,
  });
}

// 售水订单打印数据
export function getPrintData(data) {
  return request({
    url: '/payOrderWater/getPrintData',
    method: 'get',
    params: { orderNo: data },
  });
}
// 批量打印
export function getBatchPrintData(data) {
  return request({
    url: '/payOrderWater/getBatchPrintData',
    method: 'post',
    data: data,
  });
}
